import API from './API.js'

export default class MasterType extends API {
  constructor() {
    super('masterType')
  }
}
